import { useCallback, useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import AwardsStrip from "@/components/AwardsStrip";
import Marquee from "@/components/Marquee";
import Projects from "@/components/Projects";
import About from "@/components/About";
import Contact from "@/components/Contact";
import ReelModal from "@/components/ReelModal";
import Games from "@/components/Games";
import { Toaster } from "@/components/ui/sonner";

function Home({ onPlayReel }) {
    return (
        <main>
            <Hero onPlayReel={onPlayReel} />
            <AwardsStrip />
            <Marquee />
            <Projects />
            <About />
            <Contact />
        </main>
    );
}

export default function App() {
    const lenisRef = useRef(null);
    const [reelOpen, setReelOpen] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        if (reelOpen) lenisRef.current?.stop();
        else lenisRef.current?.start();
    }, [reelOpen]);

    const scrollTo = useCallback((target) => {
        lenisRef.current?.scrollTo(target, { duration: 1.6 });
    }, []);

    const openReel = useCallback(() => setReelOpen(true), []);
    const closeReel = useCallback(() => setReelOpen(false), []);

    return (
        <BrowserRouter>
            <div className="min-h-screen bg-[#050505] text-[#F5F5F7]">
                <div className="noise-overlay" aria-hidden="true" />
                <Nav onNavigate={scrollTo} onPlayReel={openReel} />
                <Routes>
                    <Route path="/" element={<Home onPlayReel={openReel} />} />
                    <Route path="/games" element={<Games />} />
                </Routes>
                <ReelModal open={reelOpen} onClose={closeReel} />
                <Toaster theme="dark" position="bottom-right" />
            </div>
        </BrowserRouter>
    );
}
